import React, { useState } from "react";
import PropTypes from "prop-types";

const FontInput = ({ frame, fontSettings, updateFontSize, templateSettings }) => {
  const [warningDelivered, updatedWarningDelivered] = useState(false);

  const originalFontSize = () => {
    try {
      return fontSettings[frame.id].size;
    } catch (err) {
      return null;
    }
  };

  const validateFontSize = (fontSize) => {
    if (!warningDelivered && fontSize && originalFontSize() && (fontSize > originalFontSize())) {
      Notify.makeAll('dormant');
      Notify.create({
        type: "error",
        title: t("Font size larger than original"),
        body: t("If text disappears, shrink font size.")
      });
      updatedWarningDelivered(true);
    }
  };

  const handleFontChange = (fontSize) => {
    validateFontSize(parseInt(fontSize, 10));
    updateFontSize(fontSize);
  };

  if (templateSettings.allowFontSizing) {
    return (
      <label htmlFor={`${frame.id}-fontSize`} className="font-size">
        {t("Font Size")}
        <input
          type="number"
          onChange={(e) => handleFontChange(e.target.value)}
          defaultValue={originalFontSize()}
          className="font-size"
        />
        <span className="font-size-pixels">px</span>
      </label>
    );
  }

  return null;
};

FontInput.propTypes = {
  frame: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  updateFontSize: PropTypes.func.isRequired,
  fontSettings: PropTypes.shape({}).isRequired,
  templateSettings: PropTypes.shape({
    allowFontSizing: PropTypes.bool
  }).isRequired,
};

export default FontInput;
